import { Accordion, AccordionDetails } from '@mui/material';
import React from 'react';
import { escapeDanger } from '../../utilities/function';

function Details(props) {
    const { content } = props;

    return (
        <div
           >
            <div style={{ transition: '1s', overflowX: 'auto' }}>
                <div dangerouslySetInnerHTML={{ __html: escapeDanger(content) }}></div>

                {/* <Box sx={{ p: 2 }}>
                    <Typography variant='h5' sx={{ pb: 3 }}>
                        Contract: {jobType}
                    </Typography>
                    <Typography variant='h5'>Salary:{salary}</Typography>
                </Box> */}
            </div>
        </div>
    );
}

export default Details;
